import React from 'react'
// import { ImDrive } from 'react-icons/im'
import styled from "styled-components"
import { NewCard } from './NewCard'

const Div = styled.div`

display:flex;
flex-direction:row;
flex-wrap:wrap;
gap:150px;
justify-content:center;
align-items:center;
// margin:10px;
// border:1px solid red;
@media (max-width:360px){
    display:flex;
    flex-direction:column;
    margin:0px;
}
@media (max-width:640px){
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    margin:0px;
    // border:2px solid red;
    
}
@media (max-width:900px)
{   display:flex;
    flex-wrap:wrap;
   
}   
.zoom{
    transition: transform .2s; /* Animation */
    width: 25%;
    height: 100%;
    margin-left:1rem;
    margin-right:1rem;
    &:hover{
        transform: scale(1.05);
        border-radius:5px;
        style-list:none;
    }
}
@media (max-width:360px)
    {
        .zoom{
            width:100%;
        }
    }
    @media (max-width:640px)
    {
        .zoom{
    
            width:100%;
        }
    }
`

const Projects = () => {
    const arr=[{img:"vocab-app.png",title:"Vocab app",github_link:"https://github.com/aejaz1995/Vocab-app",demo_link:"https://vocab-app-aejaz1995.vercel.app/",description:"Simple repository of vocabulary user can add new words to his repository",mui:true,react:true,redux:true,mongodb:true,express:true,nodejs:true},
               {img:"spotify.png",title:"Spotify",github_link:"https://github.com/aejaz1995/Spotify",
                description:"This is clone of famous music web app.where user can login to see playlists.",js:true,react:true},{img:"new_york_times.png",title:"The New York Times",demo_link:"https://github.com/lokeshnimje/NYtimes.com-Clone",github_link:"https://github.com/aejaz1995/Pentane/tree/main/pentane-nytimes",
                description:"A news website where user can see updates and breaking news from around the world.",react:true,redux:true,mui:true},{img:"audioplayer.png",title:"Audio Player",demo_link:"https://audio-player-alpha.vercel.app/",github_link:"https://github.com/aejaz1995/SalesKen",
                description:"Simple static column graph visualizer based audio player app.",html:true,css:true,js:true},{img:"stopwatch.png",title:"Stopwatch and Timer",demo_link:"https://stopwatch-ten.vercel.app/",github_link:"https://github.com/masai-course/ti_008-aejaz/tree/master/unit-3/sprint-2/day-1/assignments/timer_stopwatch",description:"This is a simple Stopwatch plus Timer. Where user can start and set time.",css:true,html:true,js:true,react:true}]
    return (
        <div style={{marginTop:"25vh"}}>
        <div id="projects">
            <h1 style={{textAlign:"center"}}>Projects</h1>

           <Div>          
            {arr.map((item, i) =><span className="zoom" key={i}><NewCard {...item} /></span>)}
           </Div>
        </div>
        {/* <div style={{borderTop: '2px solid #fff', marginLeft:"100px",marginTop:"20px", marginRight:"80px"}}></div> */}
        </div>
    )
}

export { Projects }
